import { ChakraProvider } from "@chakra-ui/react";
import { lazy, Suspense } from "react";
import { Navigate, Route, BrowserRouter, Routes } from "react-router-dom";
import theme from "./helpers/theme";
import MainPage from "./pages/MainPage";

const ColorsShowcase = lazy(() => import("./pages/ColorsPage"));
const DevClePalettePage = lazy(() => import("./pages/DevClePalettePage"));
const NotFoundPage = lazy(() => import("./pages/NotFoundPage"));
const PrivacyPage = lazy(() => import("./pages/PrivacyPage"));
const ServicePage = lazy(() => import("./pages/ServicePage"));
const TermsPage = lazy(() => import("./pages/TermsPage"));

function App() {
  return (
    <ChakraProvider theme={theme}>
      <BrowserRouter>
        <Suspense fallback={null}>
          <Routes>
            <Route path="/colors" element={<ColorsShowcase />} />
            <Route path="/dev/cle-palette" element={<DevClePalettePage />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route
              path="/service/:slug"
              element={<Navigate to="/learning/belonging" replace />}
            />
            <Route path="/learning/:slug" element={<ServicePage />} />
            <Route path="/" element={<MainPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </ChakraProvider>
  );
}

export default App;
